// @flow
import * as React from 'react';
import * as api from '../api';
import actionTypes from '../reducers/actionTypes';
import rootReducer from '../reducers';
import Config from '../lib/Config';
import Merchant from '../lib/Merchant';
import type {
  TActionCreators,
  TAsyncLinkAccountActionCreatorOptions,
  TAsyncLinkPlaidAccountActionCreatorOptions,
  TAsyncLinkPlaidAccountActionCreatorResults,
  TRootState,
} from '../reducers';
import type { TMerchantsQuery } from '../reducers/merchants';


function getActions(state: TRootState, dispatch): TActionCreators {
  const request = api.init(state.config);

  /**
   * Navigation
   */
  function navigateTo(path: string, state?: ?any) {
    dispatch({ type: actionTypes.NAVIGATE_TO, payload: { navigation: { current: { path, state } } } });
  }

  function navigateBack() {
    dispatch({ type: actionTypes.NAVIGATE_BACK, payload: {} });
  }

  /**
   * Config
   */
  async function asyncFetchConfig(): Promise<Config> {
    const type = actionTypes.FETCH_CONFIG;
    const config = await request({ type });
    const initializedConfig = Config.init({
      ...state.config.toObject(),
      ...config,
    }).set('initialized', true);
    dispatch({ type, payload: { config: initializedConfig } });
    return initializedConfig;
  }

  /**
   * Merchants
   */
  async function asyncFetchMerchants(query: TMerchantsQuery): Promise<Array<Merchant>> {
    const type = actionTypes.FETCH_MERCHANTS;
    // $FlowFixMe
    const merchantsList: Array<Merchant> = (await request({ type, data: query })).map(Merchant.init);
    dispatch({ type, payload: { merchants: { query, list: merchantsList  } } });
    return merchantsList;
  }

  /**
   * Accounts
   */
  async function asyncLinkAccount(data: TAsyncLinkAccountActionCreatorOptions): Promise<string> {
    const type = actionTypes.LINK_ACCOUNT;
    // $FlowFixMe
    return (await request({ type, data }));
  }

  async function asyncLinkPlaidAccount(
    data: TAsyncLinkPlaidAccountActionCreatorOptions,
  ): Promise<TAsyncLinkPlaidAccountActionCreatorResults> {
    const type = actionTypes.LINK_PLAID_ACCOUNT;
    // $FlowFixMe
    return (await request({ type, data }));
  }

  async function asyncLinkMXAccount(data: { member_guid: string }): Promise<string> {
    const type = actionTypes.LINK_PLAID_ACCOUNT;
    // $FlowFixMe
    return (await request({ type, data }));
  }

  async function async_delete_link_token(): Promise<void> {
    const type = actionTypes.DELETE_LINK_TOKEN;
    try {
      // $FlowFixMe
      await request({ type, data: null })
    } catch (_) {}
    return;
  }

  return {
    navigateTo,
    navigateBack,
    asyncFetchConfig,
    asyncFetchMerchants,
    asyncLinkAccount,
    asyncLinkPlaidAccount,
    asyncLinkMXAccount,
    async_delete_link_token,
  };
}

export default function withRootReducer(Component: any): (props: any) => React.Node {
  return function (props: any): React.Node {
    const [state, dispatch] = React.useReducer(rootReducer, {});
    const actions = getActions(state, dispatch);

    // Initialize store
    React.useEffect(() => { dispatch({ type: actionTypes.INIT }); }, []);

    return <Component {...props} {...state} {...actions} />;
  }
}
